<template>
    <ui-card-toggle
        design="brightness"
        set-status
        :open="true"
    >
        <template #title>
            <div class="title-units">
                <ui-square-th />

                <span>Visualizar Unidades</span>
            </div>
        </template>

        <template #content>
            <div class="switch-header">
                <ui-switch
                    data-ui="config-units-users-group"
                    design="xs"
                    label="Ativar <b>permissionamento</b> para visualização de unidades do empreendimento."
                    font-size="13px"
                    v-model="form.active"
                    :checked="form.active"
                />
            </div>

            <transition name="small-fade">
                <div v-if="loading.body" class="loading-card">
                    <ui-load-indicator bgColor="#e7e9f4" color="#3FACFF" :h="50" :stroke="8" />
                </div>
            </transition>

            <p v-if="!loading.body && form.active" class="text-select-groups">Quais grupos de usuários podem visualizar as unidades do empreendimento?</p>

            <div v-if="!loading.body && form.active" class="content-products-units scroll-color-primary">
				<div v-for="(fields, index) in form.permissions" :key="index" class="container-switch">
                    <span>{{ fields.name }}</span>
                    <ui-switch design="xs" v-model="fields.active" :checked="fields.active" />
				</div>
            </div>

            <div v-if="!loading.body && form.active" class="personalize-message">
                <em class="fal fa-comment-alt-lines" />
                <span @click="openPersonalizeMessageModal">Personalizar Mensagens para usuários.</span>
            </div>

            <div v-if="!loading.body && form.active" class="groups-users">
                <span>Os Grupos de Usuários desativados também <span class="not-reserves">não poderão fazer reservas</span> das unidades deste empreendimento.</span>
            </div>

            <div class="footer-products-units">
                <ui-button
                    design="success md"
                    :disabled="!canSubmit"
                    @click="submitPermissionsUnits"
                >
                    <span v-if="loading.button" class="loading-submit-teams">
                        <ui-load-indicator bg-color="#fff" color="#41A870" :h="20" :stroke="6" />
                    </span>

                    Salvar
                </ui-button>
            </div>
        </template>
    </ui-card-toggle>
</template>

<script>
import { uiLoadIndicator } from '@/components/ui'
import { uiButton } from '@/components/ui/buttons'
import { uiCardToggle } from '@/components/ui/cards'
import { uiSwitch } from '@/components/ui/form'
import { alertMixin, formMixin } from '@/mixins'
import { product } from '@/services/axios'

const defaultForm = () => ({
    active: false,
    name: '',
    permissions: []
})

const defaultLoader = () => ({
    button: false,
    body: false
})

export default {
    name: 'ui-permissions-units',

    components: {
        uiCardToggle,
        uiButton,
        uiSwitch,
        uiLoadIndicator
    },

	mixins: [
		alertMixin,
        formMixin
	],

    data() {
        return {
            form: { ...defaultForm() },
            id: null,
            loading: { ...defaultLoader() },
            oldForm: {},
        }
    },

	computed: {
		canSubmit() {
			return this.$mx_isFormChanged && !this.loading.body && !this.loading.button
		},
	},

	async mounted() {
        this.id = this.$route.params.id
		await this.load()
        this.$mx_copyOldForm()
	},

    methods: {
		async load() {
            this.loading.body = true
			try {
				const { data } = await product.listUnitsPermissions(this.id)

                this.$root.$emit('name-permissions-units', data.data.name)
                this.form.active = data.data.active
				this.form.permissions = this.formatPermissions(data.data.permissions)

                this.loading.body = true
			} catch (error) {
				if (error.data?.msg) {
					this.$mx_alertError(error.data.msg)
				}
                this.loading.body = false
			} finally {
                this.loading.body = false
			}
		},

		formatPermissions(data) {
            const order = ["Colaborador", "Supervisor", "Gerente", "Corretor"];

            const translations = {
                supervisor: "Supervisor",
                manager: "Gerente",
                broker: "Corretor",
                collaborator: "Colaborador"
            };

            // Mapeia o array e substitui os valores do campo "name" conforme necessário
            return data.map(permission => ({
                ...permission,
                name: translations[permission.name] || permission.name // Mantém o original se não houver tradução
            })).sort((a, b) => {
                const indexA = order.indexOf(a.name)
                const indexB = order.indexOf(b.name)

                // Se ambos estão no array de ordem, segue a posição definida
                if (indexA !== -1 && indexB !== -1) return indexA - indexB

                // Se apenas um deles está no array, ele deve vir antes
                if (indexA !== -1) return -1
                if (indexB !== -1) return 1

                // Caso ambos não estejam na ordem definida, mantém a posição relativa
                return 0
            })
		},

        openPersonalizeMessageModal() {
            this.$root.$emit('modal-open-personalize-message')
        },

        async submitPermissionsUnits() {
            const groups = this.form.permissions.filter(item => item.active).map(item => item.id)
            this.loading.button = true
            try {
                const response = await product.postPermissionsUnits(this.id, { active: this.form.active ,group_ids: groups })
                this.$mx_copyOldForm()
                this.$mx_alertSuccess(response.data.msg)
                this.loading.button = false
            } catch (error) {
                if (error.data?.msg) {
                    this.$mx_alertError(error.data.msg)
				} else {
                    this.$mx_alertError(error)
				}
                this.loading.button = false
            } finally {
                this.loading.button = false
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>